import {
  BlacklistDataContent,
  BlacklistUserInfo,
  ButtonPseudo,
  MatchStatusEnum,
  PermissionEnum,
  Popup,
  Select,
  SidePanel,
  SidePanelType,
  Textarea,
  TransactionWarningActionEnum,
} from '@ui/src';
import { OngoingMonitoringPopupsTypes } from '../types';

import cn from '../styles.module.css';

const OngoingMonitoringPopups = ({
  setApplyAllPopupVisible,
  setComment,
  setMatchStatus,
  setAction,
  onApplyActions,
  batchApplyWarningInProgress,
  comment,
  action,
  matchStatus,
  applyAllPopupVisible,
  ongoingWithoutActions,
  activePermissions,
  blacklistDataVisible,
  setBlacklistDataVisible,
  setBlacklistData,
  blacklistData,
  blacklistItemVisible,
  setBlacklistDataItem,
  setBlacklistItemVisible,
  blacklistItem,
}: OngoingMonitoringPopupsTypes) => (
  <>
    <Popup
      title="Select status and action"
      description="This will be applied to all matches in the group"
      onCancelClick={() => {
        setApplyAllPopupVisible(false);
        setComment('');
        setMatchStatus('');
        setAction('');
      }}
      onOkClick={onApplyActions}
      cancelButtonText="Cancel"
      okButtonText={batchApplyWarningInProgress ? 'Loading...' : 'Apply to all'}
      okButtonDisabled={
        !comment || !action || !matchStatus || batchApplyWarningInProgress
      }
      isVisible={applyAllPopupVisible}
    >
      <div className={cn.applyAllContent}>
        <Select
          name="matchStatus"
          value={matchStatus}
          onChange={(e) => setMatchStatus(e.target.value as string)}
          list={[
            {
              name: 'False',
              value: MatchStatusEnum.FALSE,
            },
            {
              name: 'True',
              value: MatchStatusEnum.TRUE,
            },
            {
              name: 'Potential',
              value: MatchStatusEnum.POTENTIAL,
            },
          ]}
          placeholder="Select Match status"
          disabled={
            !ongoingWithoutActions.length || batchApplyWarningInProgress
          }
          className={cn.matchStatusSelect}
          fullWidth
        />
        <Select
          name="actions"
          value={action}
          onChange={(e) => setAction(e.target.value as string)}
          list={[
            {
              name: 'Pass all time for this client',
              value: TransactionWarningActionEnum.PASS_ALL_TIME_FOR_THIS_CLIENT,
              hidden: !activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_ACCEPT_ACTION,
              ),
            },
            {
              name: 'Pass combination',
              value: TransactionWarningActionEnum.PASS_COMBINATION,
              hidden: !activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_ACCEPT_ACTION,
              ),
            },
            {
              name: 'Pass once',
              value: TransactionWarningActionEnum.PASS_ONCE,
              hidden: !activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_ACCEPT_ACTION,
              ),
            },
            {
              name: 'Stop',
              value: TransactionWarningActionEnum.STOP,
              hidden: !activePermissions?.includes(
                PermissionEnum.APPLICATIONS_CUSTOMERS_AML_REJECT_ACTION,
              ),
            },
          ]}
          placeholder="Select actions"
          className={cn.matchStatusSelect}
          disabled={
            !ongoingWithoutActions.length || batchApplyWarningInProgress
          }
          fullWidth
        />
        <Textarea
          name="comment"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Enter a comment..."
          disabled={
            !ongoingWithoutActions.length || batchApplyWarningInProgress
          }
        />
      </div>
    </Popup>
    <SidePanel
      closeOnClickOutside
      type={SidePanelType.Transactions}
      isOpen={blacklistDataVisible}
      onClose={() => {
        setBlacklistDataVisible(false);
        setBlacklistData(undefined);
      }}
      title={blacklistData?.fullName as string}
      sidepanelExpandedKey="customers-ongoing-monitoring-blacklist"
      footer={
        <ButtonPseudo
          text="Close"
          onClick={() => {
            setBlacklistDataVisible(false);
            setBlacklistData(undefined);
          }}
          bold
        />
      }
    >
      <BlacklistDataContent data={blacklistData} />
    </SidePanel>
    <SidePanel
      type={SidePanelType.Transactions}
      closeOnClickOutside
      isOpen={blacklistItemVisible}
      onClose={() => {
        setBlacklistDataItem(undefined);
        setBlacklistItemVisible(false);
      }}
      title="User Details"
      sidepanelExpandedKey="customers-ongoing-monitoring-blacklist"
      footer={
        <ButtonPseudo
          text="Close"
          onClick={() => {
            setBlacklistDataItem(undefined);
            setBlacklistItemVisible(false);
          }}
          bold
        />
      }
      withoutExpand
      expanded
    >
      <BlacklistUserInfo info={blacklistItem} isLoading={false} />
    </SidePanel>
  </>
);

export default OngoingMonitoringPopups;
